var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoFilter24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ico_filter",
    transform: "translate(-2.526 -11.208)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19693",
    "data-name": "Rectangle 19693",
    width: 24,
    height: 24,
    transform: "translate(2.526 11.208)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49640",
    "data-name": "Path 49640",
    d: "M22.5,18.45a.91.91,0,0,1-.92.9H7.42a.91.91,0,0,1-.92-.9v-.841a.91.91,0,0,1,.92-.9H21.58a.91.91,0,0,1,.92.9Z",
    transform: "translate(.026 .5)",
    fill: "#8d939c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49641",
    "data-name": "Path 49641",
    d: "M31.983,44.409a.91.91,0,0,1-.92.9H22.42a.91.91,0,0,1-.92-.9v-.841a.91.91,0,0,1,.92-.9h8.644a.91.91,0,0,1,.92.9Z",
    transform: "translate(-12.215 -20.78)",
    fill: "#8d939c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49642",
    "data-name": "Path 49642",
    d: "M41.466,70.367a.91.91,0,0,1-.92.9H37.42a.91.91,0,0,1-.92-.9v-.841a.91.91,0,0,1,.92-.9h3.126a.91.91,0,0,1,.92.9Z",
    transform: "translate(-24.456 -42.061)",
    fill: "#8d939c"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoFilter24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_filter24x24.d0dc6944d4b562834eba425f405bb441.svg";